import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useForm, Controller } from "react-hook-form";
import { Redirect } from "react-router-dom";
// @material-ui/core components
import {
  Grid,
  Typography,
  TextField,
  Link,
  Icon,
  CircularProgress,
  Hidden,
  Button,
  Paper,
  Avatar,
  IconButton,
  InputAdornment,
  Tabs,
  Tab,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Divider,
} from "@material-ui/core";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
// @material-ui/styles
import { makeStyles } from "@material-ui/core/styles";
import styles from "../../assets/jss/layouts/appStyle";
import SignUpIcon from "@material-ui/icons/PersonAdd";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import PersonIcon from "@material-ui/icons/Person";
import LockIcon from "@material-ui/icons/Lock";
import EmailIcon from "@material-ui/icons/Email";
// core components
import { changeLanguage, LOCALE } from "../../properties/Locale";
import { LoginRepository } from "./LoginRepository";
import {
  notifyShowSuccessMessage,
  notifyShowErrorMessage,
  COMMON_ACTIONS,
} from "../../common/actions/CommonActions";
import { AuthService } from "../../auth/AuthService";
import Snackbar from "../../common/components/Snackbar/Snackbar.js";
import { validateLoginForm, validateCreateUserForm } from "./LoginValidations";
import { AuthRepository } from "../../auth/AuthRepository";
import { MunicipalitiesRepository } from "../configuration/municipalities/MunicipalitiesRepository";
import { SchoolsRepository } from "../configuration/schools/SchoolsRepository";
import { ReCaptcha } from "react-recaptcha-v3";
import { loadReCaptcha } from "react-recaptcha-v3";

const useStyles = makeStyles(styles);

export default function LoginComponent() {
  const classes = useStyles();
  const counter = useSelector((state) => state);
  const {
    handleSubmit: loginUserForm,
    register: registerLoginUser,
    errors: errorsLoginUser,
  } = useForm({
    validationSchema: validateLoginForm,
  });
  const {
    handleSubmit: createUserForm,
    register: registerCreateUser,
    errors: errorsCreateUser,
    setValue,
    getValues,
    control,
  } = useForm({
    validationSchema: validateCreateUserForm,
  });

  const dispatch = useDispatch();
  const [rerender, triggerRerenderLocal] = React.useState(false);
  const [loading, setLoading] = useState(counter.loading);
  const [municipalities, setMunicipalities] = useState();
  const [schools, setSchools] = useState();
  const [redirect, setRedirect] = useState(null);
  const [step, setStep] = useState(0);
  const [showPassword, setShowPassword] = useState(false);
  const [schoolType, setschoolType] = useState();
  const [ownedBy, setOwnedBy] = useState();
  const [municipalityId, setMunicipalityId] = useState();
  const [recaptcha, setRecaptcha] = useState();
  const [recaptchaToken, setRecaptchaToken] = useState();
  const [resetPasswordEmail, setResetPasswordEmail] = useState();
  const values = getValues();

  useEffect(() => {
    loadReCaptcha("6LdB2akZAAAAABhbL1yR7jSU2WOuPz77sZF9XbzE", verifyCallback);
    MunicipalitiesRepository.fetchAllMunicipalities({
      page: 0,
      size: 100,
      orderBy: "name",
      orderDirection: "ASC",
    })
      .then((res) => {
        setMunicipalities(res.data);
      })
      .catch((err) => {});
  }, []);

  const verifyCallback = (recaptchaToken) => {
    // Here you will get the final recaptchaToken!!!
    setRecaptchaToken(recaptchaToken);
  };

  const updateToken = () => {
    // you will get a new token in verifyCallback
    recaptcha.execute();
  };

  useEffect(() => {
    if (
      schoolType != undefined &&
      ownedBy != undefined &&
      municipalityId != undefined
    ) {
      SchoolsRepository.fetchAllSchoolsByMunicipalityTypeOwnedBy({
        municipalityId: municipalityId,
        schoolType: schoolType,
        ownedBy: ownedBy,
      }).then(
        (res) => {
          setSchools(res.data);
        },
        (err) => {}
      );
    }
  }, [schoolType, ownedBy, municipalityId]);

  const handleChangeLocale = (e) => {
    changeLanguage(e);
  };

  const handleDateChange = (date) => {
    setValue("dateOfBirth", date);
    triggerRerenderLocal(!rerender);
  };

  const onLoginUser = (values) => {
    setLoading(true);
    AuthRepository.fetchToken(values).then(
      (res) => {
        AuthService.setToken(res.data);
        setTimeout(function () {
          setRedirect("/app/dashboard");
        }, 500);
      },
      (err) => {
        setLoading(false);
        if (
          err.response?.data?.error_description?.includes(
            "UserDetailsService returned null, which is an interface contract violation"
          )
        ) {
          dispatch(notifyShowErrorMessage("Users email is not verified"));
        } else if (err.response?.data?.error_description) {
          dispatch(
            notifyShowErrorMessage(err.response?.data?.error_description)
          );
        } else {
          dispatch(notifyShowErrorMessage(err.response?.data?.error));
        }
      }
    );
  };
  const onCreateUser = (values) => {
    values.name = values.teacher.firstName + " " + values.teacher.lastName;
    setLoading(true);
    const user = [values][0];

    LoginRepository.createUser(user, recaptchaToken).then(
      (res) => {
        dispatch(
          notifyShowSuccessMessage(
            LOCALE.login_createuser_success + res.data.name
          )
        );
        setTimeout(function () {
          setStep(0);
          setLoading(false);
        }, 700);
      },
      (err) => {
        if (
          err.response?.data?.message &&
          err.response?.data?.message.includes("ConstraintViolationException")
        ) {
          dispatch(
            notifyShowErrorMessage(
              "Веќе постои корисник со исто корисничко име или е-пошта"
            )
          );
        } else if (
          err.response?.data?.message &&
          err.response?.data?.message.includes(
            "TransientPropertyValueException"
          )
        ) {
          dispatch(notifyShowErrorMessage("Училиште е задолжително поле"));
        } else {
          dispatch(
            notifyShowErrorMessage(err.response?.data?.error_description)
          );
        }
        updateToken();
        setLoading(false);
      }
    );
  };

  const onMuniciChange = (event) => {
    setMunicipalityId(event.target.value);
  };

  const onOwnedChange = (event) => {
    setOwnedBy(event.target.value);
  };

  const onTypeChange = (event) => {
    setschoolType(event.target.value);
  };

  const handleClose = () => {
    if (counter.open) {
      dispatch({
        type: COMMON_ACTIONS.CLEAR_NOTIFICATIONS,
        payload: null,
      });
    }
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const forgotPassword = () => {
    LoginRepository.getResetPasswordLink(resetPasswordEmail).then((res) => {
      dispatch(
        notifyShowSuccessMessage(LOCALE.succesfuly_send_password_reset_mail)
      );
    });
  };

  if (redirect) {
    return <Redirect to={redirect} />;
  }
  return (
    <div className={classes.loginWrapper}>
      <Hidden smDown implementation="css">
        <div className={classes.loginLeftPanel}>
          <img
            alt=""
            src={require("../../assets/img/grb.png")}
            width="200px"
            style={{ marginTop: "15%", opacity: "50%" }}
          ></img>
          <Typography component="h1" variant="h2" style={{ opacity: "60%" }}>
            <p style={{ fontSize: "18pt" }}>{LOCALE.login_h1}</p>
            {LOCALE.login_h2}
          </Typography>
        </div>
      </Hidden>

      <div className={classes.loginRightPanel}>
        <Hidden mdUp implementation="css">
          <div style={{ padding: "10px" }}>
            <img
              alt=""
              src={require("../../assets/img/grb.png")}
              width="40px"
              style={{ opacity: "50%" }}
            ></img>
            <Typography component="h1" variant="h2" style={{ opacity: "60%" }}>
              <p style={{ fontSize: "7pt" }}>{LOCALE.login_h1}</p>
              <p style={{ fontSize: "10pt" }}>{LOCALE.login_h2}</p>
            </Typography>
          </div>
        </Hidden>
        {/* Login step */}
        {step === 0 && (
          <Paper className={classes.paperLogin}>
            <Grid container className={classes.gridMargin}>
              <Grid item xs={3}></Grid>
              <Grid item xs={6}>
                <Avatar className={classes.avatarLogin}>
                  <LockOutlinedIcon />
                </Avatar>
                <h2 className={classes.cardTitleGray}>{LOCALE.login_signin}</h2>
              </Grid>
              <Grid item xs={3}></Grid>
            </Grid>
            <div className={classes.panelLogin}>
              <form onSubmit={loginUserForm(onLoginUser)}>
                <div>
                  <TextField
                    variant="outlined"
                    error={errorsLoginUser?.username}
                    helperText={errorsLoginUser?.username?.message}
                    margin="normal"
                    fullWidth
                    label={LOCALE.login_username}
                    name="username"
                    autoFocus
                    inputRef={registerLoginUser}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <PersonIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>

                <div>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    error={errorsLoginUser?.password}
                    helperText={errorsLoginUser?.password?.message}
                    fullWidth
                    name="password"
                    label={LOCALE.login_password}
                    type={showPassword ? "text" : "password"}
                    id="password"
                    inputRef={registerLoginUser}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <LockIcon />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            edge="end"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
                <div style={{ marginTop: "3%", marginBottom: "3%" }}>
                  <Button
                    type="submit"
                    variant="contained"
                    fullWidth
                    color="primary"
                    disabled={loading}
                  >
                    {loading && (
                      <CircularProgress size={24} style={{ color: "white" }} />
                    )}
                    {!loading && LOCALE.login_signin}
                  </Button>
                </div>
              </form>
              <Grid container style={{ marginTop: "15px" }}>
                <Grid item xs style={{ textAlign: "left" }}>
                  <Link
                    style={{ cursor: "pointer" }}
                    variant="body2"
                    onClick={() => setStep(2)}
                  >
                    {LOCALE.login_forgot_password_link}
                  </Link>
                </Grid>
                <Grid item>
                  <Link
                    style={{ cursor: "pointer" }}
                    variant="body2"
                    onClick={() => setStep(1)}
                  >
                    {LOCALE.login_signup_link}
                  </Link>
                </Grid>
              </Grid>
              <Grid container style={{ marginTop: "25px" }}>
                <Grid item xs={9}></Grid>
                <Grid item xs>
                  {/* <Link
                    style={{ cursor: "pointer" }}
                    variant="body2"
                    onClick={() => handleChangeLocale("en")}
                  >
                    EN
                  </Link> */}
                </Grid>
                <Grid item xs>
                  <Link
                    style={{ cursor: "pointer" }}
                    variant="body2"
                    onClick={() => handleChangeLocale("mk")}
                  >
                    МК
                  </Link>
                </Grid>
                <Grid item xs>
                  <Link
                    variant="body2"
                    onClick={() => handleChangeLocale("al")}
                  >
                    AL
                  </Link>
                </Grid>
              </Grid>
            </div>
          </Paper>
        )}
        {step === 1 && (
          <Paper className={classes.paperLogin}>
            <Grid container className={classes.gridMargin}>
              <Grid item xs={3}>
                <IconButton
                  style={{
                    color: "black",
                  }}
                  onClick={() => setStep(0)}
                >
                  <Icon>arrow_back_ios</Icon>
                </IconButton>
              </Grid>
              <Grid item xs={6}>
                <Avatar className={classes.avatarLogin}>
                  <SignUpIcon />
                </Avatar>
                <h2 className={classes.cardTitleGray}>{LOCALE.login_signup}</h2>
              </Grid>
              <Grid item xs={3}></Grid>
            </Grid>
            <div className={classes.panelLogin}>
              <form onSubmit={createUserForm(onCreateUser)}>
                <FormControl
                  variant="outlined"
                  fullWidth
                  size="small"
                  margin="dense"
                  error={errorsCreateUser?.type}
                >
                  <InputLabel>{LOCALE.role}</InputLabel>
                  <Controller
                    as={
                      <Select label={LOCALE.role}>
                        <MenuItem value="TEACHER">{LOCALE.teacher}</MenuItem>
                        <MenuItem value="ASSOCIATE">
                          {LOCALE.associate}
                        </MenuItem>
                      </Select>
                    }
                    name="type"
                    control={control}
                    defaultValue={null}
                  />
                  <FormHelperText id="municipality-helper-text">
                    {errorsCreateUser?.type?.message}
                  </FormHelperText>
                </FormControl>
                <Grid container>
                  <Grid item xs={6} style={{ paddingRight: "6px" }}>
                    <FormControl
                      variant="outlined"
                      fullWidth
                      size="small"
                      margin="dense"
                    >
                      <InputLabel>{LOCALE.owned_by}</InputLabel>
                      <Select
                        label={LOCALE.owned_by}
                        defaultValue=""
                        onChange={onOwnedChange}
                      >
                        <MenuItem value="">None</MenuItem>
                        <MenuItem value="MUNICIPALITY">
                          {LOCALE.municipality_school}
                        </MenuItem>
                        <MenuItem value="COUNTRY">
                          {LOCALE.country_school}
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={6}>
                    <FormControl
                      variant="outlined"
                      fullWidth
                      size="small"
                      margin="dense"
                    >
                      <InputLabel>{LOCALE.school_type}</InputLabel>
                      <Select
                        label={LOCALE.school_type}
                        defaultValue=""
                        onChange={onTypeChange}
                      >
                        <MenuItem value="">None</MenuItem>
                        <MenuItem value="ELEMENTARY_SCHOOL">
                          {LOCALE.elementary_school}
                        </MenuItem>
                        <MenuItem value="MIDDLE_SCHOOL">
                          {LOCALE.middle_school}
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
                <FormControl
                  variant="outlined"
                  fullWidth
                  size="small"
                  margin="dense"
                >
                  <InputLabel>{LOCALE.municipality}</InputLabel>
                  <Select
                    label={LOCALE.municipality}
                    defaultValue=""
                    onChange={onMuniciChange}
                  >
                    <MenuItem value="">None</MenuItem>
                    {municipalities?.content.map((municipality) => (
                      <MenuItem key={municipality.id} value={municipality.id}>
                        {municipality.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>

                <FormControl
                  variant="outlined"
                  fullWidth
                  size="small"
                  margin="dense"
                >
                  <InputLabel>{LOCALE.school}</InputLabel>
                  <Controller
                    as={
                      <Select label={LOCALE.school}>
                        <MenuItem value="">None</MenuItem>
                        {schools?.map((schools) => (
                          <MenuItem key={schools.id} value={schools.id}>
                            {schools.name}
                          </MenuItem>
                        ))}
                      </Select>
                    }
                    name="teacher.school.id"
                    control={control}
                    defaultValue=""
                  />
                </FormControl>
                <br />
                <br />
                <Grid container>
                  <Grid item xs={6} style={{ paddingRight: "6px" }}>
                    <TextField
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      size="small"
                      label={LOCALE.login_firstname}
                      name="teacher.firstName"
                      autoFocus
                      inputRef={registerCreateUser}
                      error={errorsCreateUser?.teacher?.firstName}
                      helperText={errorsCreateUser?.teacher?.firstName?.message}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <PersonIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      size="small"
                      label={LOCALE.login_lastname}
                      name="teacher.lastName"
                      inputRef={registerCreateUser}
                      error={errorsCreateUser?.teacher?.lastName}
                      helperText={errorsCreateUser?.teacher?.lastName?.message}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <PersonIcon />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                </Grid>
                <FormControl fullWidth>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Controller
                      as={
                        <KeyboardDatePicker
                          disableToolbar
                          inputVariant="outlined"
                          format="MM/dd/yyyy"
                          margin="dense"
                          id="date-from"
                          label={LOCALE.dateOfBirth}
                        />
                      }
                      name="teacher.birthDate"
                      control={control}
                      size="small"
                    />
                  </MuiPickersUtilsProvider>
                </FormControl>
                <TextField
                  variant="outlined"
                  margin="dense"
                  fullWidth
                  size="small"
                  label={LOCALE.login_email}
                  name="email"
                  inputRef={registerCreateUser}
                  error={errorsCreateUser?.email}
                  helperText={errorsCreateUser?.email?.message}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <EmailIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  variant="outlined"
                  error={errorsCreateUser?.username}
                  helperText={errorsCreateUser?.username?.message}
                  margin="dense"
                  fullWidth
                  size="small"
                  label={LOCALE.login_username}
                  name="username"
                  inputRef={registerCreateUser}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <PersonIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                <Grid container>
                  <Grid item xs={6} style={{ paddingRight: "6px" }}>
                    <TextField
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      size="small"
                      name="password"
                      label={LOCALE.login_password}
                      type={showPassword ? "text" : "password"}
                      inputRef={registerCreateUser}
                      error={errorsCreateUser?.password}
                      helperText={errorsCreateUser?.password?.message}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <LockIcon />
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              edge="end"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {showPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      size="small"
                      name="confirmPassword"
                      label={LOCALE.login_confirm_password}
                      type={showPassword ? "text" : "password"}
                      inputRef={registerCreateUser}
                      error={errorsCreateUser?.confirmPassword}
                      helperText={errorsCreateUser?.confirmPassword?.message}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <LockIcon />
                          </InputAdornment>
                        ),
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              edge="end"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {showPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item xs={2}></Grid>
                  <Grid item xs={8}>
                    <ReCaptcha
                      ref={(ref) => setRecaptcha(ref)}
                      sitekey="6LdB2akZAAAAABhbL1yR7jSU2WOuPz77sZF9XbzE"
                      action="register"
                      verifyCallback={verifyCallback}
                    />
                  </Grid>
                  <Grid item xs={2}></Grid>
                </Grid>
                <div style={{ marginTop: "3%", marginBottom: "15%" }}>
                  <Button
                    type="submit"
                    variant="contained"
                    fullWidth
                    color="primary"
                    disabled={loading}
                  >
                    {loading && (
                      <CircularProgress size={24} style={{ color: "white" }} />
                    )}
                    {!loading && LOCALE.login_signup}
                  </Button>
                </div>
              </form>
            </div>
          </Paper>
        )}
        {/* Forgot Password */}
        {step === 2 && (
          <Paper className={classes.paperLogin}>
            <Grid container className={classes.gridMargin}>
              <Grid item xs={3}>
                <IconButton
                  style={{
                    color: "black",
                  }}
                  onClick={() => setStep(0)}
                >
                  <Icon>arrow_back_ios</Icon>
                </IconButton>
              </Grid>
              <Grid item xs={6}>
                <Avatar className={classes.avatarLogin}>
                  <Icon>vpn_key</Icon>
                </Avatar>
                <h2 className={classes.cardTitleGray}>
                  {LOCALE.login_forgot_password}
                </h2>
              </Grid>
              <Grid item xs={3}></Grid>
            </Grid>
            <div className={classes.panelLogin}>
              <form>
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label={LOCALE.login_email}
                  name="email"
                  autoFocus
                  value={resetPasswordEmail}
                  onChange={(e) => setResetPasswordEmail(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <EmailIcon />
                      </InputAdornment>
                    ),
                  }}
                />
                <div style={{ marginTop: "3%", marginBottom: "3%" }}>
                  <Button
                    variant="contained"
                    fullWidth
                    color="primary"
                    disabled={loading}
                    onClick={() => forgotPassword()}
                  >
                    {loading && (
                      <CircularProgress size={24} style={{ color: "white" }} />
                    )}
                    {!loading && LOCALE.login_submit}
                  </Button>
                </div>
              </form>
            </div>
          </Paper>
        )}
      </div>

      {counter.open && (
        <Snackbar
          place="br"
          icon={counter.variant}
          color={counter.variant}
          message={counter.message}
          open={true}
          closeNotification={handleClose}
          close
        />
      )}
    </div>
  );
}
